import { render, staticRenderFns } from "./ModulePlaceholder.vue?vue&type=template&id=96f10292&"
import script from "./ModulePlaceholder.vue?vue&type=script&lang=js&"
export * from "./ModulePlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports